<template>
  <!-- 发票查询 -->
  <div class="page-container" id="ebOrderContainer">
    <el-form
      :model="searchData"
      ref="ruleFormRef"
      class="form-panel"
      label-position="top"
      :validateOnRuleChange="false"
    >
      <el-row class="content-panel">
        <el-row :gutter="22">
          <el-col :span="5">
            <el-form-item label="InvoiceSerial No">
              <el-input
                size="mini"
                v-model="searchData.invoiceSerialNo"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="Invoice No">
              <el-input size="mini" v-model="searchData.invoiceNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="IssuedDate From">
              <el-date-picker
                v-model="searchData.issuedDateFrom"
                align="right"
                type="date"
                style="width: 100%"
                size="mini"
                placeholder=""
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="IssuedDate To">
              <el-date-picker
                v-model="searchData.issuedDateTo"
                align="right"
                type="date"
                style="width: 100%"
                size="mini"
                placeholder=""
                :picker-options="pickerOptions"
                @change="changeissuedDateTo"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Invoice Type">
              <el-select clearable v-model="searchData.invoiceType" placeholder="Please select an invoice type">
                <el-option
                  v-for="item in invoiceTypeList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-button class="el-button-search" type="primary" size="small" plain @click="queryForm"
          >Search</el-button
          >
          <el-button type="info" size="small" plain @click="resetForm"
          >Reset
          </el-button
          >
        </el-row>

        <!-- </div> -->

        <!-- 表格-start -->
        <el-row style="margin-top: 15px">
          <hot-table
            ref="ebOrderTableRef"
            :data-source="bcInvoiceTableDataSource"
            :settings="bcInvoiceTableSettings"
            col-settings-key="bcInvoice"
            @rowDblclick="bcInvoiceRowClick"
          >
            <hot-column
              :has-tip="true"
              data="invoiceSerialNo"
              title="InvoiceSerial No"
              width="150"
            >
              <el-input-editor hot-editor data="invoiceSerialNo"/>
              <!-- <column-link-renderer hot-renderer></column-link-renderer> -->
            </hot-column>
            <hot-column
              :has-tip="true"
              data="invoiceNo"
              title="Invoice No"
              width="150"
            >
              <!-- <el-input-editor hot-editor data="invoiceNo"/> -->
            </hot-column>

            <hot-column
              :has-tip="true"
              data="invoiceCode"
              title="Invoice Code"
              width="150"
            >
              <!-- <el-input-editor hot-editor data="invoiceCode"/> -->
            </hot-column>

            <hot-column
              :has-tip="true"
              data="issuedDate"
              date-format="YYYY-MM-DD"
              title="Issued Date"
              width="150"
            >
              <!-- <el-input-editor hot-editor data="issuedDate"/> -->
            </hot-column>
            <hot-column
              :has-tip="true"
              data="invoiceType"
              title="Invoice Type"
              width="150"
              dictName="MD_CODE_BC_INVOICE_TYPE"
            >
              <!-- <el-input-editor hot-editor data="invoiceType"/> -->
            </hot-column>
            <hot-column
              :has-tip="true"
              data="settleCustName"
              title="SettleCust Name"
              width="150"
            >
              <!-- <el-input-editor hot-editor data="settleCustName"/> -->
            </hot-column>
            <hot-column
              :has-tip="true"
              data="taxpayerIdentificatioNo"
              title="TaxpayerIdentificatio No"
              width="150"
            >
              <!-- <el-input-editor hot-editor data="taxpayerIdentificatioNo"/> -->
            </hot-column>
            <hot-column
              :has-tip="true"
              data="invoiceAmount"
              title="Invoice Amount"
              width="150"
            >
              <!-- <el-input-editor hot-editor data="invoiceAmount"/> -->
            </hot-column>
          </hot-table>
        </el-row>
        <!-- 分页start -->
        <div class="pg_div">
          <el-pagination
            :current-page="pageConfig.currentPage"
            :layout="pageConfig.layout"
            :page-size="pageConfig.pageSize"
            :page-sizes="pageConfig.pageSizes"
            :total="pageConfig.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
        <!-- 分页end -->
        <!-- 表格-end -->
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { queryInvoice } from "@/api/queryMainSystem";
import { queryDictRows } from "@/api/commonService";

export default {
  data() {
    return {
      invoiceTypeList: [], //发票类型
      //日期设置
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      bcInvoiceId: null,
      bcInvoice: {
        invoiceSerialNo: null,
        invoiceNo: null,
        invoiceCode: null,
        issuedDate: null,
        invoiceType: null,
        notify: null,
        taxpayerIdentificatioNo: null,
        invoiceAmount: null,
      },

      searchData: {
        isDetail: null,
        invoiceSerialNo: null,
        invoiceNumber: null,
        issuedDateFrom: null,
        issuedDateTo: null,
        invoiceType: null,
        overseasAgent: "Y"
      },

      // 分页
      pageConfig: {
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        pageSize: 100,
        pagerCount: 100,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
      },

      // 表格校验
      ebOrderRules: {},
      // 表格数据
      bcInvoiceTableDataSource: [],
      // 表格设置
      bcInvoiceTableSettings: {
        height: 360,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
    };
  },
  async created() {

  },
  mounted() {
    let self = this;
    self.queryDictRows();
    // 监听外层容器div宽度的变化，做表格自适应
    self.resizeObserver = new ResizeObserver((entries) => {
      self.$nextTick(() => {
        self.$refs.ebOrderTableRef.resizeTo(entries[0].target.clientWidth - 32);
      });
    });
    self.resizeObserver.observe(document.getElementById("ebOrderContainer"));
  },
  methods: {
    bcInvoiceRowClick(val) {
      let row = val.record;
      if (val !== 1){
        this.$router.push({
          name: 'InvoiceDetailInternational',
          params: {
            ebInvoiceId: row.bcInvoiceId,
            type: 'edit'
          }
        })
      }
    },
    changeissuedDateTo() {
      let self = this;
      self.searchData.issuedDateTo = new Date(self.searchData.issuedDateTo.getTime() + 1000 * 24 * 3600 - 100)
    },
    //暂时修改为MD_CODE_BC_INVOICE_TYPE
    queryDictRows() {
      let self = this;
      queryDictRows("MD_CODE_DICT$MD_CODE_BC_INVOICE_TYPE").then((res) => {
        self.invoiceTypeList = res.MD_CODE_DICT$MD_CODE_BC_INVOICE_TYPE;
        let dict = [];
        res.MD_CODE_DICT$MD_CODE_BC_INVOICE_TYPE.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          dict.push(param);
        });
        console.log(dict)
        self.$hotTableUtils.registDict({
          'MD_CODE_BC_INVOICE_TYPE': dict,
        });
      });
    },
    //点击
    clickModule(e) {
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      let self = this;
      self.queryStatusPage();
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageConfig.currentPage = val;
      let self = this;
      self.queryStatusPage();
    },
    // 单击行事件
    rowClick(val) {
      let self = this;
      self.currentEbOrder = val.record;
    },
    // tab切换事件
    handleClick(tab, event) {
      let self = this;
      self.pageConfig.currentPage = 1;
      self.queryStatusPage();
    },
    queryStatusPage() {
      let self = this;
      self.queryForm();
    },
    //重置搜索框
    resetForm() {
      this.searchData = {};
    },
    //查询
    queryForm() {
      let self = this;
      self.queryButton = 2;
      let num = 0;
      for (let s in self.searchData) {
        if (self.searchData[s] !== null) {
          num++;
        } else {
          delete self.searchData[s]
        }
      }
      if (num === 0) {
        self.$coreMethods.message("warning", "至少输入一个查询条件");
      } else {
        self.searchData.isDetail = "N";
        self.searchData.currentPage = self.pageConfig.currentPage;
        self.searchData.pageSize = self.pageConfig.pageSize;
        queryInvoice(self.searchData).then((res) => {
          if (res.success) {
            if (res.records) {
              self.bcInvoiceTableDataSource = res.records.records;
              self.pageConfig.total = res.records.totalRecord;
            }
            if (res.records.totalRecord === 0){
              self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
            }else {
              self.$coreMethods.message("success", "查询成功！");
            }
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
</style>
